import { useProspects } from '@/api/b2b/getOpportunities';
import { useSnoozeCustomer } from '@/api/b2b/snooze';
import { CustomerOpportunityColumn } from './CustomerOpportunityColumn';

export const ProspectsColumn = () => (
  <CustomerOpportunityColumn
    useData={useProspects}
    useSnooze={useSnoozeCustomer}
    testid="b2b-prospects"
    title="Prospects"
    subtitle="Inquired or org, not yet booked"
    emptyLabel="No prospects due right now."
    linkBase="/customers/customer"
  />
);
